var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        ref: "button",
        on: {
          click: function($event) {
            return _vm.toggle()
          }
        }
      },
      [_vm._t("dropdown-button")],
      2
    ),
    _c(
      "div",
      { ref: "content", staticClass: "z-50" },
      [
        _c(
          "transition",
          {
            attrs: {
              "enter-active-class": "transition duration-100 ease-out",
              "enter-class": "transform scale-75 opacity-0",
              "enter-to-class": "transform scale-100 opacity-100",
              "leave-active-class": "transition duration-75 ease-in",
              "leave-class": "transform scale-100 opacity-100 ",
              "leave-to-class": "transform scale-75 opacity-0"
            }
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isOpen,
                    expression: "isOpen"
                  }
                ],
                staticClass:
                  "w-56 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "py-1 text-left",
                    attrs: {
                      role: "menu",
                      "aria-orientation": "vertical",
                      "aria-labelledby": "options-menu"
                    },
                    on: {
                      click: function($event) {
                        return _vm.toggle()
                      }
                    }
                  },
                  [_vm._t("dropdown-content")],
                  2
                )
              ]
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }